// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { useMemo } from 'react';
import ElementSelector from '../../utils/FormWidgets/ElementSelector';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import DragnDropTable from '../../utils/DragnDrop/DragnDropTable';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import AmbassadorElement from './AmbassadorElement';
import NoAvatar from '../../../NoAvatar.jpg';
import CollapsableItem from '../../utils/CollapsableItem';

const AmbassadorDataBox = ({
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  guide,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  ambassadors,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  addAmbassador,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  changeGuideState,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  ambassadorActions,
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line react/prop-types
  isExpanded,
}) => {
  const mappedAmbassadors = useMemo(() => {
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line react/prop-types
    return ambassadors.map(ambassador => ({
      value: ambassador,
      label: ambassador.name,
      icon: ambassador.photo || NoAvatar,
    }));
  }, [ambassadors]);

  return (
    <div className='data-box'>
      <h4 className='header'>City Ambassador</h4>
      <CollapsableItem isExpanded={isExpanded}>
        <ElementSelector
          // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
          // @ts-ignore
          value={null}
          placeholder='Select ambassador to add'
          onChange={addAmbassador}
          options={mappedAmbassadors}
          // TODO: Fix this the next time the file is edited.
          // eslint-disable-next-line react/prop-types
          isDisabled={guide.ambassador}
        />
        <div className='clearfix' />
        {/* TODO: Fix this the next time the file is edited. */}
        {/* eslint-disable-next-line react/prop-types */}
        {guide.ambassador && (
          <DragnDropTable
            // TODO: Fix this the next time the file is edited.
            // @ts-ignore
            // eslint-disable-next-line react/prop-types
            content={[guide.ambassador]}
            onChange={changeGuideState}
            notHeader
            actions={ambassadorActions}
            receiver='ambassador'
            Element={AmbassadorElement}
          />
        )}
      </CollapsableItem>
    </div>
  );
};

export default React.memo(AmbassadorDataBox);
